import { useAppContext } from 'Context/ReactAppContext';
import { usePageContext } from 'Context/PageContext';
import * as trackingApi from 'Tracking/tracking-api';
import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants';
type TrackingAttribute = string | number | boolean | null | { neolaneID: string };
export type TrackingPayload = Readonly<{
  actionGA?: string;
  categoryGA?: string;
  labelGA?: string;
  pageName?: string;
  user?: {
    neolaneID: string;
  };
  [key: string]:
    | TrackingAttribute
    | null
    | undefined
    | Array<Record<string, TrackingAttribute | null | undefined>>;
}>;
export const useTracking = (defaultPayload?: TrackingPayload) => {
  const appContext = useAppContext();
  const { siteSection, pageType } = usePageContext();
  const payload = { ...GA_DEFAULT_PAYLOAD, siteSection, ...defaultPayload };
  return (trackPayload?: TrackingPayload) => {
    trackingApi.setDataLayer(
      { ...payload, ...trackPayload },
      appContext,
      pageType.replace(/ple/g, 'PLE'),
    );
  };
};
